const BASE_URL = "https://krumago-application-assets.s3.us-east-1.amazonaws.com/Education+Domain+Assets/";


export const EDUCATION = {

    IMAGES: {
        IMAGE_1: `${BASE_URL}customer-care.jpg`,
    },
};